import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hudiara',
  templateUrl: './hudiara.component.html',
  styleUrls: ['./hudiara.component.css']
})
export class HudiaraComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hudiara/hudiara.component.ts